/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AUMSCustomPortionRequestResponse
 */
export interface AUMSCustomPortionRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'status'?: AUMSCustomPortionRequestResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'calories'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'protein'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'carbs'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSCustomPortionRequestResponse
     */
    'fat'?: number;
}

export const AUMSCustomPortionRequestResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Adjusted: 'ADJUSTED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type AUMSCustomPortionRequestResponseStatusEnum = typeof AUMSCustomPortionRequestResponseStatusEnum[keyof typeof AUMSCustomPortionRequestResponseStatusEnum];


